import React, { useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import { isMobileDevice, isHarmonyOS, isExist } from "cxa-utils";
import { RouteMap } from "../common/navigation/routeMap";
import { logoutIDP, authorizeUserSession } from "../../actions/loginActions";
import { upgradeUserSession } from "../../actions/ssoActions";
import qs from "querystring";
import { Button } from "cxa-components";
import messages from "components/messagesDescription";
import { injectIntl, intlShape } from "react-intl";
import { withRouter } from "react-router-dom";

const ExternalLoginPP = ({ intl }) => {
  const dispatch = useDispatch();
  const { isLogoutIDPFetching, isLogoutIDPFetched } = useSelector(state => state.login);
  const { isUpgradeSessionFetching, isUpgradeSessionFetched } = useSelector(state => state.sso);
  const { allowMobileBrowserSSOLogin } = useSelector(state => state.common.clientSettings);

  let sessionData = null;
  const allowToAccessOnce =
    !isLogoutIDPFetching &&
    !isLogoutIDPFetched &&
    !isUpgradeSessionFetching &&
    !isUpgradeSessionFetched;

  const doRedirect = sp => {
    let ssoReturnUrl = RouteMap.CXAMain;

    if (sp === "1") ssoReturnUrl = "/sso/idp/login-assert";
    const storedUrl = sessionStorage.getItem("ssoReturnUrl");
    if (isExist(storedUrl)) ssoReturnUrl = storedUrl;
    if (allowMobileBrowserSSOLogin || isHarmonyOS(navigator.userAgent)) {
      ssoReturnUrl = RouteMap.CXAMain;
    } else if (isMobileDevice(navigator.userAgent) && sessionData && sessionData.encryptedToken) {
      ssoReturnUrl = `ppcxa://sso/login?token=${encodeURIComponent(sessionData.encryptedToken)}`;
    }
    // eslint-disable-next-line xss/no-location-href-assign
    location.href = ssoReturnUrl;
  };

  const returnToApp = () => {
    const sessionDataLocal = JSON.parse(localStorage.getItem("sessionData"));
    if (sessionDataLocal && sessionDataLocal.encryptedToken) {
      // eslint-disable-next-line xss/no-location-href-assign
      location.href = `ppcxa://sso/login?token=${encodeURIComponent(
        sessionDataLocal.encryptedToken
      )}`;
    }
  };

  useEffect(() => {
    if (!allowToAccessOnce) return;

    const fetchSessionData = async () => {
      const query = qs.parse(location.search.substring(1));
      const { nonce, requiresOAuth, sp } = query;
      const isRequiresOAuth = isExist(requiresOAuth) && requiresOAuth.toLowerCase() === "true";

      dispatch(logoutIDP());
      sessionData = await dispatch(upgradeUserSession(nonce));
      localStorage.setItem("sessionData", JSON.stringify(sessionData));
      if (isRequiresOAuth) {
        await dispatch(authorizeUserSession());
        doRedirect(sp);
      }
    };

    fetchSessionData();
  }, []);

  return isMobileDevice(navigator.userAgent) ? (
    <div style={{ padding: "10px" }}>
      <p>{intl.formatMessage(messages.loginFallbackDescription)}</p>
      <Button
        primary
        type="button"
        onClick={returnToApp}
        style={{ width: "100%", marginTop: "20px", backgroundColor: "#0E6DBE" }}
      >
        {intl.formatMessage(messages.returnToAppDescription)}
      </Button>
    </div>
  ) : null;
};

ExternalLoginPP.propTypes = {
  intl: intlShape.isRequired,
};

export default withRouter(injectIntl(ExternalLoginPP));



// WEBPACK FOOTER //
// ./components/login/ExternalLoginPP.jsx